// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1MeT7","actions":"GroupTable_actions__1WlD1","deleteModalFooter":"GroupTable_deleteModalFooter__3dM2k"};